<template>
  <li
    :class="{
      i: message.employer.id === employerData.id,
      'friend-with-a-SVAGina': message.employer.id !== employerData.id,
    }"
  >
    <div v-if="section" class="head">
      <!--<span class="time">10:13 AM, Today</span>-->
      <span class="name">
        {{ `${message.employer.first_name} ${message.employer.last_name}` }}
      </span>
    </div>

    <div v-if="message.message !== ''" :class="{ message: true, hasPrev: !section }">
      <div>
        {{ message.message }}
      </div>
    </div>

    <div v-if="message.hasOwnProperty('attachments')">
      <div v-for="attach in message.attachments" class="attachment">
        <a v-if="imageOrAnotherFile(attach)" :href="storagePath + attach.filename" target="_blank">
          <img :src="storagePath + attach.filename" class="attach_file" />
        </a>

        <a v-else :href="storagePath + attach.filename" target="_blank"> Открыть </a>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    message: Object,
    employerData: Object,
    section: Boolean,
  },
  computed: {
    storagePath() {
      return this.$config.modules.crm.storage
    },
  },
  methods: {
    imageOrAnotherFile(attachLink) {
      return /\.(gif|jpg|jpeg|tiff|png)$/i.test(attachLink.filename)
    },
  },
}
</script>
